<template>
  <div v-loading="tableLoading" >
    <el-table :data="obj.data" class="table">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column label="好友ID" prop="payFaiUuid" width="300" class="font-bold"></el-table-column>
      <el-table-column label="奖励金额" prop="inviterMoney" width="300" class="font-bold"></el-table-column>
      <el-table-column label="发放状态" prop="auditStatus" width="100" class="font-bold">
        <template slot-scope="scope">
          <p v-if="scope.row.auditStatus == 1">发放中</p>
          <p v-else-if="scope.row.auditStatus == 2">已发放</p>
          <p v-else>已失效</p>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="obj.count"
    ></el-pagination>
  </div>
</template>

<script>

export default {
  props: {
    obj:{
      type:Object
    },
    // 带有默认值的对象
    data: {
      type: Array
    }
  },
  computed: {
    tableData() {
      return this.data;
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      tableLoading: false
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.$emit("sizeChange", val);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("pageChange", val);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>


</style>